import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=4e804626"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"
import style0 from "./Download.vue?vue&type=style&index=0&id=4e804626&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Viberary/repos/viberary-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports